import CollapsibleSection from "components/Section";
import React, { useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";
import { TWaterSubscriber } from "types/dto";
import { Grid } from "components/Grid";
import { useGridDetailsContextMenu } from "components/Grid/hooks/useGridDetailsContextMenu";

type TProps = {
  data?: TWaterSubscriber[];
  isLoading: boolean;
};
export const RelatedWaterSubscribers = (props: TProps) => {
  const { data, isLoading } = props;

  const { t } = useTranslation();

  const gridRef = useRef(null);

  // Rows are TWaterSubscriber, so `id` is the subscriber id.
  const subscriberDetailsContextMenu = useGridDetailsContextMenu((row) =>
    row?.id ? `/dashboard/subscribers/details/${row.id}` : undefined
  );

  const renderRelatedWaterSubscribers = useCallback(() => {
    if (data) {
      return (
        <>
          <p className={"text-sm text-gray-90 font-bold"}>
            {t("relatedWaterSubscribersToApartment")}:
          </p>
          <Grid
            ref={gridRef}
            gridKey={"id"}
            rowContextMenu={subscriberDetailsContextMenu}
            dataSource={data}
            columns={[
              {
                dataField: "id",
                caption: t("id"),
              },
              {
                dataField: "floorNo",
                caption: t("floorNo"),
              },
              {
                dataField: "unitNo",
                caption: t("unitNo"),
              },
              {
                dataField: "subscriberName",
                caption: t("subscriberName"),
              },
              {
                dataField: "identifierId",
                caption: t("identifierId"),
              },
              {
                dataField: "nationalId",
                caption: t("nationalId"),
              },
              {
                dataField: "phoneNumber",
                caption: t("phoneNumber"),
              },
              {
                dataField: "mobileNumber",
                caption: t("mobileNumber"),
              },
              {
                dataField: "postalCode",
                caption: t("postalCode"),
              },
              {
                dataField: "email",
                caption: t("email"),
              },
            ]}
            hasSearchPanel={false}
            hasPagination={false}
            hasGroupingFeatures={false}
            hasFilterBuilder={false}
          />
        </>
      );
    }
  }, [data]);

  return (
    <CollapsibleSection
      title={t("subscribers")}
      collapsible={true}
      isLoading={isLoading}
      skeleton="table"
    >
      {renderRelatedWaterSubscribers()}
    </CollapsibleSection>
  );
};
